<div style="text-align: center;">
    <label
        style="text-decoration: underline; color: #115740; text-align: center; margin-bottom: 100px;margin-block: revert; margin:75px;">
        Endorsement screen
    </label>
</div>